import React from 'react';
import { logEvent } from '../util/apiUtils';

/**
 * Displays a Recommended Product card
 *
 * @param props.recommendedProduct The product details (title, description, imageUrl, productPage)
 * @param addToOrder A function to call, passing the product, to kick off the process of adding the product to an order
 */
const ProductCard = ({ recommendedProduct, addToOrder }) => {
	if (!recommendedProduct) {
		return null;
	}

	const logDetailsClicked = (event) => {
		logEvent(
			'{} - Recommended Products "Details" clicked. recommendedProduct={}',
			'RECOMMENDED_PRODUCTS_DETAILS_CLICK',
			recommendedProduct.omsOrderableItemId
		);

		return true;
	}

	return (
		<div className="col-sm-4 col-xs-12">
			<div className="recommended-product-card">
				<div className="recommended-product-heading">
					{recommendedProduct.imageUrl ? (
						<img
							src={recommendedProduct.imageUrl}
							className="recommended-product-logo"
							alt={recommendedProduct.title}
						/>
					) : (
						<h4>{recommendedProduct.title}</h4>
					)}
				</div>
				<div>{recommendedProduct.description}</div>
				<div className="recommended-product-card-actions">
					{recommendedProduct.productPage && (
						<>
							<a
								href={recommendedProduct.productPage}
								target="_blank"
								rel="noopener noreferrer"
								style={{ textTransform: 'none' }}
								className="btn btn-sm btn-white mt-0 mb-0"
								onClick={logDetailsClicked}
							>
								Details
							</a>
							<div className="visible-sm-block mt-10"></div>
							<span className="hidden-sm ml-10"></span>
						</>
					)}

					<button
						onClick={() => addToOrder(recommendedProduct)}
						className="btn btn-sm btn-default mt-0 mb-0"
						style={{ textTransform: 'none' }}
					>
						Add to Order
					</button>
				</div>
			</div>
		</div>
	);
};

export default ProductCard;
